import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Container,
  WebContainer,
  Wrapper,
  Title,
  Copy
} from "app/NativeComponents/common";
import { Header } from "app/NativeComponents/snippets";
import Engines from "app/DealMachineCore/components/SelectPlans/Engines";
import {
  /*mobile*/
  toggleCanPop,
  appRedirect,
  toggleActionSheet,
  updateUser,
  saveCard,
  logout,
  billingFieldChanged,
  authFieldChanged,
  updatePlan,
  resetSelectedPlan,
  resetBilling,
  selectPlan,
  togglePlanFrequency,
  setDemoPage,
  toggleDemoPage,
  setPaymentPage,
  togglePaymentPage,
  dismissMobileKeyboard
} from "app/NativeActions";

class Canceled extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selected_engine_tab: "driving",
      selected_frequency: "annually",
      selected_engines: []
    };

    this.selectEngine = this.selectEngine.bind(this);
    this.selectEngineTab = this.selectEngineTab.bind(this);
    this.onFrequencySwitch = this.onFrequencySwitch.bind(this);
  }

  selectEngine(engine) {
    this.props.setPaymentPage({
      engine_slug: engine.engine,
      tier: engine.tier,
      frequency: engine.frequency,
      onSuccess: () => {
        this.props.appRedirect({
          redirect: "dashboard"
        });
      }
    });
    this.props.togglePaymentPage(true);
  }

  selectEngineTab(selected_engine_tab) {
    this.setState({
      selected_engine_tab,
      selected_frequency:
        selected_engine_tab == "messages"
          ? "monthly"
          : this.state.selected_frequency
    });
  }

  onFrequencySwitch(selected_frequency) {
    this.setState({
      selected_frequency
    });
  }

  componentDidMount() {
    if (this.props.device == "mobile") {
      this.props.toggleCanPop("");
    }

    if (this.props.user.canceled != 1) {
      this.props.appRedirect({ redirect: "dashboard" });
    }
  }

  handleBack() {
    this.props.logout({ token: this.props.token });
  }

  renderCopy() {
    if (this.props.user.paused_account == 1) {
      return (
        <Wrapper>
          <Wrapper
            style={{
              alignItems: "center",
              justifyContent: "center",
              padding: 20
            }}
          >
            <Title>
              You have paused your DealMachine Account. Your data is still
              intact.
            </Title>
            <Copy>
              Select a plan below to reactivate your account and restore your
              data.
            </Copy>
          </Wrapper>
          <Engines
            selected_engine={this.state.selected_engine_tab}
            selectEngineTab={this.selectEngineTab}
            onEngineSelect={this.selectEngine}
            onDemoPress={demo => {
              this.props.setDemoPage({
                title: demo.title,
                webinar_id: demo.webinar_id
              });
              this.props.toggleDemoPage(true);
            }}
            include_annual_toggle={
              this.state.selected_engine_tab == "messages" ? false : true
            }
            onFrequencySwitch={this.onFrequencySwitch}
            selected_frequency={this.state.selected_frequency}
          />
        </Wrapper>
      );
    } else {
      return (
        <Wrapper
          style={{
            alignItems: "center",
            justifyContent: "center",
            padding: 20
          }}
        >
          <Title>You have canceled your DealMachine Account.</Title>
          <Copy>
            Please talk to customer support if you wish to reactivate.
          </Copy>
        </Wrapper>
      );
    }
  }
  render() {
    return (
      <Container fill>
        <Header
          title={
            this.props.user.paused_account == 1
              ? "Paused Account"
              : "Canceled Account"
          }
          leftButtonIcon="arrow-back"
          leftButtonAction={this.handleBack.bind(this)}
        />
        <WebContainer style={{ maxWidth: "100%" }}>
          {this.renderCopy()}
        </WebContainer>
      </Container>
    );
  }
}

const mapStateToProps = ({ auth, native, billing, drawer }) => {
  const { token, user, accepted_terms } = auth;
  const { device, platform } = native;
  const { card, price, selected_plan, frequency, loading } = billing;
  const { stats } = drawer;

  return {
    token,
    user,
    device,
    platform,
    card,
    price,
    selected_plan,
    frequency,
    stats,
    loading,
    accepted_terms
  };
};

export default connect(mapStateToProps, {
  /*mobile*/
  toggleCanPop,

  appRedirect,
  toggleActionSheet,
  updatePlan,
  updateUser,
  saveCard,
  logout,
  billingFieldChanged,
  authFieldChanged,
  resetSelectedPlan,
  resetBilling,
  selectPlan,
  setDemoPage,
  toggleDemoPage,

  togglePlanFrequency,
  setPaymentPage,
  togglePaymentPage
})(Canceled);
